import angularModule from 'Onboarding/angularModule/scripts/onboarding_module';
import { setupBrandNameProperties } from 'AppBranding';
import template from 'Onboarding/angularModule/views/onboarding.hybrid.login.html';
import cacheAngularTemplate from 'cacheAngularTemplate';

import logoSmall from 'images/onboarding/Logo-Small@2x.png';
import logoSmallQuantic from 'vectors/logos/quantic-logo-rebrand.svg';

const templateUrl = cacheAngularTemplate(angularModule, template);

angularModule.directive('onboardingHybridLogin', [
    '$injector',
    function factory($injector) {
        const NavigationHelperMixin = $injector.get('Navigation.NavigationHelperMixin');
        const ConfigFactory = $injector.get('ConfigFactory');
        const EventLogger = $injector.get('EventLogger');

        return {
            restrict: 'E',
            templateUrl,
            scope: {},
            link(scope) {
                const reactRouterBridge = $injector.get('reactRouterBridge');
                const searchParams = reactRouterBridge.search();
                EventLogger.log('debug_onboarding_issue:onboarding_hybrid_login_init', {
                    params: { searchParams },
                });

                NavigationHelperMixin.onLink(scope);

                const config = ConfigFactory.getSync();
                setupBrandNameProperties($injector, scope, { config });

                const isQuantic = config.isQuantic();
                const previousScreen = searchParams.previous;

                Object.defineProperty(scope, 'logoSmall', {
                    get() {
                        if (isQuantic) {
                            return logoSmallQuantic;
                        }
                        return logoSmall;
                    },
                });

                scope.logoWidth = isQuantic ? 150 : 50;
                scope.logoHeight = isQuantic ? 40 : 50;

                scope.showBack = previousScreen === 'register' || previousScreen === 'start';

                scope.goBack = () => {
                    const whereToGo =
                        previousScreen === 'start' ? '/onboarding/hybrid?finished' : '/onboarding/hybrid/register';
                    scope.loadRoute(whereToGo);
                };
            },
        };
    },
]);
